module.exports = __webpack_public_path__ + "d86d23c8e2b4e612353fa91d59a4ec65.svg";